import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/travel_phenomena_cover.jpg'

const SunSmartPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>Travel Phenomena</h3>
                <div className="project-content">

                    <p>„When Yeow Mei Jyn, 33, travels, she has a carry-on luggage that weighs close to 10kg containing nothing but gadgets! She brings along two phones […], two cameras […], lenses, an external hard drive and, on shorter trips, a laptop. (No, this flashpacker is not a photographer)“ (Revathi Murugappan 2010)</p>
                    <p>We are living in a world that has to deal with mediatisation, globalisation, pluralisation, individualisation and acceleration. These social and cultural changes cause people to develop strategies and postmodern phenomena occur.</p>
                    <p>The research examines numerous travel blogs with a cultural studies perspective to analyse the phenomena of Backpackers and Flashpackers. Based on the processes of globalization, all parts of life accelerated and mediatized. It changes the understanding of how to perceive time and space. With the background of a globalized world, modalities of travelling and coping strategies emerge. Phenomena of the postmodern world, as Backpackers and Flashpackers, developed their own point of view of this world. The focus of the analysis describes the experience of time and space while travelling through the globalized world.</p>
                    <p>A further analysis of the material will be provided upon request.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <div className="slider">
                    <ImageGallery
                        showThumbnails={false}
                        showFullscreenButton={false}
                        autoPlay={true}
                        items={[
                            { original: image1, },
                        ]} />
                </div>

                <br />
                <br />

                <p className="project-blurb">Research about the time and space perception of Backpacker and Flashpacker.</p>

                <ul className="tags">
                    <li>Travel blogs</li>
                    <li>Backpacker</li>
                    <li>Flashpacker</li>
                    <li>Cultural Studies</li>
                    <li>Phenomenology</li>
                    <li>Sociology</li>
                    <li>Communication and Media Studies</li>
                    <li>Tourism</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> O.-v.-G. University Magdeburg</p>
                    <p><span className="highlight">Source:</span> a number of selected travel blogs</p>
                    <p><span className="highlight">Date:</span> April - October 2010</p>
                </div>

            </div>
        </div>
    </div>
)

export default SunSmartPage



// WEBPACK FOOTER //
// ./src/pages/projects/travel-phenomena.js